// src/components/MonthYearSelect.jsx
import { monthOptions } from "../utils/dateUtils";

const OPTIONS = monthOptions();

export function MonthYearSelect({ value, onChange }) {
  return (
    <select className="form-select" value={value} onChange={e => onChange(e.target.value)}
      style={{ width: 140 }}>
      {OPTIONS.map(o => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  );
}
